export default __webpack_public_path__ + "static/worksans-medium-webfont-69d96b4352a85d3fff804211c26ae1bc.woff";